export const lang = {
	//titleชื่อเรื่องสําหรับแต่ละหน้า
	title: 'รายละเอียดวิธีใช้',
}
